import React, {ReactElement} from "react";
import {LoadingPlaceholder} from "@core-ui/loading-placeholder";
import {PlaceholderProps} from "./types";

export const BrRedesignPlaceholder = ({
  animationDelay = "0s",
}: PlaceholderProps): ReactElement => (
  <div
    className="placeholder-grid__container"
    style={{
      float: "left",
      overflow: "hidden",
    }}
  >
    <div style={{paddingBottom: "0"}}>
      <LoadingPlaceholder
        animationDelay={animationDelay}
        className="placeholder-grid__image"
        invert
        ratio={{width: 240, height: 325}}
      />
    </div>
  </div>
);
